// extracted by mini-css-extract-plugin
export var navbarSubLink = "L_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "L_v3 d_f0 d_dB";
export var subPageLink = "L_gf d_gf";
export var burger = "L_wr";
export var sublinkSize = "L_ws";
export var linkSize = "L_wt";
export var Link = "L_rJ q_rJ q_qW q_rf";